import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class SupplierSelectService {
    selectedSupplierKeys: string[] = [];
    constructor() {
    }
}